import styled from 'styled-components';

import BackgroundImage from '../../../../../assets/home-background.png';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
`;

export const ContentContainer = styled.div`
  max-width: 1240px;
  flex: 1;

  margin: 0 auto;
  padding: 20px;
`;

export const Content = styled.div`
  position: relative;

  color: #ffffff;

  h3 {
    font-weight: 800;
    font-size: 20px;
    line-height: 20px;
  }

  h2 {
    font-weight: 900;
    font-size: 60px;

    line-height: 60px;
  }

  h1 {
    font-weight: 900;
    font-size: 100px;
    line-height: 80px;
  }

  @media only screen and (max-width: 455px) {
    h3 {
      font-size: 4vw;
      line-height: 5vw;
    }

    h2 {
      font-size: 13vw;
      line-height: 10vw;
    }

    h1 {
      font-size: 22vw;
      line-height: 20vw;
    }
  }
`;

export const Line = styled.div`
  position: absolute;
  width: 45px;
  height: 0.5px;
  top: 3.5%;
  left: -55px;

  background-color: #ffffff;
`;

export const Details = styled.div`
  max-width: 402px;

  p {
    font-size: 15px;
    line-height: 22px;
    text-align: justify;

    padding: 15px 0px 15px 0px;
  }

  button {
    font-weight: bold;
    font-size: 15px;
    line-height: 22px;
    text-decoration: none;
    transition: color 0.2s;

    background: none;
    border-width: 0px;

    color: #ffffff;

    :hover {
      color: #386882;
    }
  }
`;
